export default __webpack_public_path__ + "static/media/smileSick.d496c901.png";